import httpService from '@/core/http-service'
import _ from 'lodash'

const state = {
  checkout: {
    selectedCardPayment: null,
    selectedShipping: null,
    preferredDeliveryGroupingKey: null,
    deliveryAddress: { countryCode: null },
    deliveryAddressId: null
  },
  activeSteps: [],
  isOrderRequestVisitor: false
}

const mutations = {
  set_checkout(state, payload) {
    state.checkout = payload
  },
  clear_checkout(state) {
    state.checkout = {
      selectedCardPayment: null,
      selectedShipping: null,
      preferredDeliveryGroupingKey: null,
      deliveryAddress: { countryCode: null },
      deliveryAddressId: null
    }
  },
  save_active_steps(state, payload) {
    state.activeSteps = payload
  },
  remove_active_steps(state, payload) {
    if (payload === undefined) {
      state.activeSteps = []
    } else if (payload.length > 0) {
      _.forEach(payload, (step) => {
        state.activeSteps = _.filter(state.activeSteps, (s) => { return s !== step })
      })
    } else {
      state.activeSteps = _.filter(state.activeSteps, (s) => { return s !== payload })
    }
  },
  set_order_request_visitor(state, payload) {
    state.isOrderRequestVisitor = payload
  }
}

const actions = {
  setCheckout({ commit, dispatch }, payload) {
    commit('set_checkout', payload)
    updateCheckoutOnServer(dispatch, payload)
  },
  clearCheckout({ commit }) {
    return new Promise((resolve, reject) => {
      commit('clear_checkout')
      commit('set_order_request_visitor', false)
      commit('remove_active_steps')
      resolve()
    })
  },
  setActiveSteps({ commit }, payload) {
    commit('save_active_steps', payload)
  },
  removeActiveSteps({ commit }, payload) {
    commit('remove_active_steps', payload)
  },
  setOrderRequestVisitor({ commit, state }, payload) {
    commit('set_order_request_visitor', payload === undefined ? !state.isOrderRequestVisitor : payload)
  }
}

const updateCheckoutOnServer = _.debounce((dispatch, payload) => {
  httpService.post('checkout/updatestatus', { payload }).then(() => {
    dispatch('commerce/getCart', 1, { root: true })
  })
}, 500)

const getters = {
  checkoutState: state => {
    return state.checkout
  },
  activeSteps: state => {
    return state.activeSteps
  },
  isOrderRequestVisitorState: state => {
    return state.isOrderRequestVisitor
  },
  isStep3Active: state => {
    return state.activeSteps.includes(3)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
